module.exports = __webpack_public_path__ + "assets/successNote5-48f39b.svg";